export default __webpack_public_path__ + "static/media/ai-center-light.452ea028.svg";